"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _gatsby = require("gatsby");

var _remark = _interopRequireDefault(require("remark"));

var _remarkParse = _interopRequireDefault(require("remark-parse"));

var _remarkReact = _interopRequireDefault(require("remark-react"));

var _remarkAttr = _interopRequireDefault(require("remark-attr"));

var _gatsbyPluginMdx = require("gatsby-plugin-mdx");

var _react2 = require("@mdx-js/react");

var _Table = _interopRequireDefault(require("./Table"));

var _Accordion = _interopRequireDefault(require("./Accordion"));

var _Form = _interopRequireDefault(require("./Form"));

var _Banner = _interopRequireDefault(require("./Banner"));

var _Carousel = _interopRequireDefault(require("./Carousel"));

var _BlogRoll = _interopRequireDefault(require("./BlogRoll"));

var _Jumbotron = _interopRequireDefault(require("./Jumbotron"));

var _Map = _interopRequireDefault(require("./Map"));

var _CurrencyConverter = _interopRequireDefault(require("./CurrencyConverter"));

var _BuildDate = _interopRequireDefault(require("./BuildDate"));

var _Checkout = _interopRequireDefault(require("./Checkout"));

var _Calculate = _interopRequireDefault(require("./Calculate"));

var shortcodes = {
  CurrencyConverter: _CurrencyConverter["default"],
  BuildDate: _BuildDate["default"],
  Checkout: _Checkout["default"],
  Calculate: _Calculate["default"]
};

var Chunk = function Chunk(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement(_react["default"].Fragment, null, props.chunk.map(function (chunk) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(_react["default"].Fragment, null, chunk.type === "text" &&
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "content ".concat(!!chunk.size ? chunk.size : "is-size-13"),
          style: {
            textAlign: "".concat(chunk.align),
            paddingBottom: "".concat(!!chunk.paddingBottom ? chunk.paddingBottom + "rem" : "2rem")
          }
        }, (0, _remark["default"])().use(_remarkParse["default"]).use(_remarkAttr["default"]).use(_remarkReact["default"]).processSync(chunk.value).contents), chunk.type === "image" &&
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "content",
          style: {
            textAlign: "".concat(chunk.align),
            paddingBottom: "1.5rem"
          }
        }, chunk.useMap !== null ?
        /*#__PURE__*/
        _react["default"].createElement("img", {
          src: !!chunk.image.childImageSharp ? chunk.image.childImageSharp.fluid.src : chunk.image,
          width: chunk.width,
          height: chunk.height,
          alt: chunk.alt,
          useMap: "#" + chunk.useMap.mapName
        }) :
        /*#__PURE__*/
        _react["default"].createElement("img", {
          src: !!chunk.image.childImageSharp ? chunk.image.childImageSharp.fluid.src : chunk.image,
          width: chunk.width,
          height: chunk.height,
          alt: chunk.alt
        }), chunk.useMap !== null ?
        /*#__PURE__*/
        _react["default"].createElement("map", {
          name: chunk.useMap.mapName
        }, chunk.useMap.area.map(function (area) {
          return (
            /*#__PURE__*/
            _react["default"].createElement("area", {
              shape: area.shape,
              coords: area.coords,
              href: area.link,
              alt: area.alt
            })
          );
        })) : null), chunk.type === "button" &&
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "content",
          style: {
            textAlign: "".concat(chunk.align),
            paddingBottom: '1.5rem'
          }
        },
        /*#__PURE__*/
        _react["default"].createElement(_gatsby.Link, {
          to: "".concat(props.langKey === "en" ? "" : props.langKey).concat(chunk.link),
          className: "button is-dark is-small"
        }, chunk.value)), chunk.type === "table" &&
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "content",
          style: {
            paddingBottom: "1.5rem"
          }
        },
        /*#__PURE__*/
        _react["default"].createElement(_Table["default"], {
          title: chunk.title !== null ? chunk.title : null,
          data: chunk
        })), chunk.type === "tableNew" &&
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "table is-striped",
          style: {
            paddingBottom: "1.5rem"
          }
        }, (0, _remark["default"])().use(_remarkParse["default"]).use(_remarkAttr["default"]).use(_remarkReact["default"]).processSync(chunk.value).contents), chunk.type === "accordion" &&
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "content",
          style: {
            textAlign: "".concat(chunk.align),
            paddingBottom: "1.5rem"
          }
        }, chunk.entries.map(function (entries) {
          return (
            /*#__PURE__*/
            _react["default"].createElement(_Accordion["default"], {
              title: entries.title,
              content: entries.content
            })
          );
        })), chunk.type === "form" &&
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "content",
          style: {
            paddingBottom: "1.5rem"
          }
        },
        /*#__PURE__*/
        _react["default"].createElement(_Form["default"], {
          data: chunk,
          langKey: props.langKey
        })), chunk.type === "banner" &&
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "content",
          style: {
            paddingBottom: "1.5rem"
          }
        },
        /*#__PURE__*/
        _react["default"].createElement(_Banner["default"], {
          data: chunk,
          langKey: props.langKey
        })), chunk.type === "carousel" &&
        /*#__PURE__*/
        _react["default"].createElement("div", {
          style: {
            paddingBottom: "1.5rem"
          }
        },
        /*#__PURE__*/
        _react["default"].createElement(_Carousel["default"], {
          data: chunk
        })), chunk.type === "blogRoll" &&
        /*#__PURE__*/
        _react["default"].createElement("div", {
          style: {
            paddingBottom: "1.5rem"
          }
        },
        /*#__PURE__*/
        _react["default"].createElement(_BlogRoll["default"], {
          langKey: props.langKey,
          isHome: chunk.isHome
        })), chunk.type === "jumbotron" &&
        /*#__PURE__*/
        _react["default"].createElement(_Jumbotron["default"], {
          data: chunk
        }), chunk.type === "map" &&
        /*#__PURE__*/
        _react["default"].createElement(_Map["default"], {
          data: chunk
        }), chunk.type === "html" &&
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "content ".concat(!!chunk.size ? chunk.size : "is-size-13"),
          style: {
            textAlign: "".concat(chunk.align),
            paddingBottom: "".concat(!!chunk.paddingBottom ? chunk.paddingBottom + "rem" : "2rem")
          },
          dangerouslySetInnerHTML: {
            __html: "".concat(chunk.value)
          }
        }), chunk.type === "include" &&
        /*#__PURE__*/
        _react["default"].createElement(_react["default"].Fragment, null, props.reusable.map(function (reusable) {
          return (
            /*#__PURE__*/
            _react["default"].createElement(_react["default"].Fragment, null, reusable.node.frontmatter.title === chunk.value &&
            /*#__PURE__*/
            _react["default"].createElement("div", {
              className: "content ".concat(!!chunk.size ? chunk.size : "is-size-13"),
              style: {
                textAlign: "".concat(chunk.align),
                paddingBottom: "".concat(!!chunk.paddingBottom ? chunk.paddingBottom + "rem" : "2rem")
              }
            },
            /*#__PURE__*/
            _react["default"].createElement(_react2.MDXProvider, {
              components: shortcodes
            },
            /*#__PURE__*/
            _react["default"].createElement(_gatsbyPluginMdx.MDXRenderer, null, reusable.node.body))))
          );
        })))
      );
    }))
  );
};

var _default = Chunk;
exports["default"] = _default;